export default __webpack_public_path__ + "static/media/401-error-wordpress-featured-image.890e6c54.jpg";